import type { Receta } from './api';

export function urlValidacionReceta(tenantId: string, recetaId: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://app.toscana-hospital.com';
  return `${origin}/r/${encodeURIComponent(tenantId)}/${recetaId}`;
}

export function telefonoWhatsAppGt(telefono: string | null | undefined): string | null {
  const digits = (telefono ?? '').replace(/\D/g, '');
  if (digits.length < 8) return null;
  return digits.startsWith('502') ? digits : `502${digits.replace(/^0+/, '')}`;
}

export function mensajeRecetaWhatsApp(opts: {
  receta: Receta;
  pacienteNombre: string;
  hospitalNombre: string;
  medicoNombre?: string | null;
  tenantId: string;
}): string {
  const { receta: r, pacienteNombre, hospitalNombre, medicoNombre, tenantId } = opts;
  const fecha = r.fecha
    ? new Date(r.fecha).toLocaleString('es-GT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : '';
  const meds = (r.items ?? []).map((it) => {
    const cant = it.cantidad != null ? ` x${it.cantidad}` : '';
    const ind = it.indicaciones?.trim() ? ` — ${it.indicaciones.trim()}` : '';
    return `• ${it.descripcion}${cant}${ind}`;
  });
  const validar = r.id ? urlValidacionReceta(tenantId, r.id) : '';
  return [
    `Receta médica — ${hospitalNombre}`,
    `Paciente: ${pacienteNombre}`,
    fecha ? `Fecha: ${fecha}` : '',
    medicoNombre ? `Médico: ${medicoNombre}` : '',
    r.diagnostico ? `Diagnóstico: ${r.diagnostico}` : '',
    meds.length ? 'Medicamentos:' : '',
    ...meds,
    validar ? `Validar receta (QR): ${validar}` : '',
  ].filter(Boolean).join('\n');
}
